import React from 'react';
import { useEffect, useState } from 'react';
import CopyButton from 'jitsi/base/buttons/CopyButton.web';
import { isIosMobileBrowser } from 'jitsi/base/environment/utils';
export const WebviewError = ({ isMeetingPage }) => {
    const [helpText, setHelpText] = useState('');
    const url = window.location.href.toString();
    useEffect(() => {
        let text = '';
        if (!isMeetingPage) {
            text =
                isIosMobileBrowser() === true
                    ? 'Please copy and paste this link into Safari browser.'
                    : 'Please copy and paste this link into chrome browser.';
        }
        else {
            text =
                isIosMobileBrowser() === true
                    ? 'To join the meeting, please copy and paste this link into Safari browser.'
                    : 'To join the meeting, please copy and paste this link into chrome browser.';
        }
        setHelpText(text);
    }, []);
    return (React.createElement("div", { className: 'pageContainer' },
        React.createElement("div", { className: 'pageLogoContainer' }),
        React.createElement("div", { className: 'whiteContainerBox' },
            React.createElement("div", { className: 'waitingContent' },
                React.createElement("div", { style: { margin: '20px', fontSize: 'medium' } },
                    helpText,
                    React.createElement("br", null),
                    React.createElement(CopyButton, { className: 'invite-more-dialog-conference-url', displayedText: url, textOnCopySuccess: 'Link copied to clipboard', textOnHover: 'Copy meeting link', textToCopy: url }))))));
};
export default WebviewError;
